import { Vector3 } from '@babylonjs/core';
import { ObstacleDistributionConfig } from '../ObstacleGenerator';
import { ObstacleBehavior } from './ObstacleBehavior';

export class ObstacleScaleBehavior extends ObstacleBehavior {
  private time: number = 0;
  constructor(startPosition: Vector3, pathIndex: number, config: ObstacleDistributionConfig) {
    super('obstacleScale', startPosition, pathIndex, config);
  }
  update(deltaTime: number): void {
    this.time += deltaTime * this.config.speed;
    // Ping pong between 0 and 1
    const t = (Math.sin(this.time) + 1) / 2;
    const scale = this.config.scaleRange.min + t * (this.config.scaleRange.max - this.config.scaleRange.min);
    this.mesh.scaling.setAll(scale);
  }
  clone(): ObstacleScaleBehavior {
    return new ObstacleScaleBehavior(this.startPosition, this.pathIndex, this.config);
  }
}
